if (!window.customElements.get("tabs-nav")) {
  class TabsNav extends HTMLElement {
    connectedCallback() {
      (this.buttons = Array.from(this.querySelectorAll("button[aria-controls]"))),
        (this.scrollerElement = this.querySelector(".tabs-nav__scroller")),
        this.buttons.forEach((button) =>
          button.addEventListener("click", () => this.selectButton(button))
        ),
        this.addEventListener("shopify:block:select", (event) =>
          this.selectButton(event.target, !event.detail.load)
        ),
        (this.positionElement = document.createElement("span")),
        this.positionElement.classList.add("tabs-nav__position"),
        this.buttons[0].parentElement.insertAdjacentElement(
          "afterend",
          this.positionElement
        ),
        window.addEventListener("resize", this._onWindowResized.bind(this)),
        this._adjustNavigationPosition(),
        this.hasArrows && this._handleArrows();
    }
    get hasArrows() {
      return this.hasAttribute("arrows");
    }
    get selectedTabIndex() {
      return this.buttons.findIndex(
        (button) => button.getAttribute("aria-expanded") === "true"
      );
    }
    get selectedButton() {
      return this.buttons.find(
        (button) => button.getAttribute("aria-expanded") === "true"
      );
    }
    selectButton(button, animate = !0) {
      if (!this.buttons.includes(button) || this.selectedButton === button)
        return;
      const from = document.getElementById(
          this.selectedButton.getAttribute("aria-controls")
        ),
        to = document.getElementById(button.getAttribute("aria-controls"));
      animate
        ? this._transitionContent(from, to)
        : ((from.hidden = !0), (to.hidden = !1)),
        this.selectedButton.setAttribute("aria-expanded", "false"),
        button.setAttribute("aria-expanded", "true"),
        this._adjustNavigationPosition();
    }
    addButton(button) {
      button.addEventListener("click", () => this.selectButton(button)),
        button.setAttribute("aria-expanded", "false"),
        this.buttons[this.buttons.length - 1].insertAdjacentElement(
          "afterend",
          button
        ),
        this.buttons.push(button),
        this._adjustNavigationPosition(!1);
    }
    _transitionContent(from, to) {
      from.animate(
        {
          opacity: [1, 0],
        },
        {
          duration: 250,
          easing: "ease",
        }
      ).onfinish = () => {
        (from.hidden = !0),
          (to.hidden = !1),
          to.animate(
            {
              opacity: [0, 1],
            },
            {
              duration: 250,
              easing: "ease",
            }
          );
      };
    }
    _onWindowResized() {
      this._adjustNavigationPosition();
    }
    _adjustNavigationPosition(shouldAnimate = !0) {
      const scale =
          this.selectedButton.clientWidth /
          this.positionElement.parentElement.clientWidth,
        translate =
          this.selectedButton.offsetLeft /
          this.positionElement.parentElement.clientWidth /
          scale,
        windowHalfWidth = this.scrollerElement.clientWidth / 2;
      this.scrollerElement.scrollTo({
        behavior: shouldAnimate ? "smooth" : "auto",
        left:
          this.selectedButton.offsetLeft -
          windowHalfWidth +
          this.selectedButton.clientWidth / 2,
      }),
        shouldAnimate || (this.positionElement.style.transition = "none"),
        this.positionElement.style.setProperty("--scale", scale),
        this.positionElement.style.setProperty(
          "--translate",
          `${translate * 100}%`
        ),
        this.positionElement.clientWidth,
        requestAnimationFrame(() => {
          this.positionElement.classList.add("is-initialized"),
            (this.positionElement.style.transition = null);
        });
    }
    _handleArrows() {
      const arrowsContainer = this.querySelector(".tabs-nav__arrows");
      arrowsContainer.firstElementChild.addEventListener("click", () => {
        this.selectButton(this.buttons[Math.max(this.selectedTabIndex - 1, 0)]);
      }),
        arrowsContainer.lastElementChild.addEventListener("click", () => {
          this.selectButton(
            this.buttons[
              Math.min(this.selectedTabIndex + 1, this.buttons.length - 1)
            ]
          );
        });
    }
  }
  window.customElements.define("tabs-nav", TabsNav);
}
